import React, { useEffect, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator'

import { useGlobal } from '../../../stores/useGlobal.js'
import { exportarXlsx } from '../../../utils/exportarArquivo.js'
import PaginacaoTabela from '../../../utils/paginacaoTabela'
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao.js'
import Alert from '../../Mantine/AlertCard/index.jsx'
import Modal from '../../Mantine/Modal/index.jsx'

import * as S from './styles.js'

const columns = [
  {
    dataField: 'ds_eid',
    text: 'EID',
    formatter: (cell) => {
      return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
    }
  },
  {
    dataField: 'ICCID',
    text: 'ICCID',
    formatter: (cell) => {
      return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
    }
  },
  {
    dataField: 'CALLERID',
    text: 'Linha',
    formatter: (cell) => {
      return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
    }
  },
  {
    dataField: 'OPERADORA',
    text: 'Rede',
    formatter: (cell) => {
      return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
    }
  },
  {
    dataField: 'TIPO_SIMCARD',
    text: 'Tipo de SIM',
    formatter: (cell) => {
      return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
    }
  }
]


export default function AlertaConfirmacaoAcao({
  onClose,
  onConfirm,
  opened,
  acao,
  linhasInvalidas = []
}) {
  const {
    linhasSelecionadas
  } = useGlobal()

  const [paginaAtual, setPaginaAtual] = useState(1)
  const [mostrarMensagemAtencao, setMostrarMensagemAtencao] = useState(false)

  useEffect(() => {
    if (linhasInvalidas.length === linhasSelecionadas.length) {
      setMostrarMensagemAtencao(true)
    }
  }, [linhasInvalidas.length, linhasSelecionadas.length])

  const handleMensagemAtencao = () => {
    setMostrarMensagemAtencao(false)
    onClose()
  }

  const valorLimite = 10

  const totalItens = linhasInvalidas.length || 0
  const totalPaginas = totalItens > 0 ? Math.ceil(totalItens / valorLimite) : 1
  const contador = (paginaAtual - 1) * valorLimite

  const TableprimaryKey = 'ICCID'
  const acaoTitle = acao?.ds_acao || 'Atenção'


  const opcoesPaginacao = {
    showTotal: true,
    sizePerPage: valorLimite,
    page: paginaAtual,
    totalSize: totalItens,
    firstPageTitle: 'Primeira',
    lastPageTitle: 'Última',
    nextPageTitle: 'Próxima',
    prePageTitle: 'Anterior',
    custom: true,
    onPageChange: (newPage) => {
      trocarPagina(newPage)
    }
  }

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const handleMontarXlsLinhasNaoEncontradas = () => {
    if (!linhasInvalidas?.length) return

    const linhas = linhasInvalidas.map((item) => [
      item.ds_eid ?? '   Vazio',
      (item.ICCID ?? '   Vazio') + '',
      "'" + (item.CALLERID ?? '   Vazio'),
      (item.OPERADORA ?? '   Vazio'),
      (item.TIPO_SIMCARD ?? '   Vazio')
    ])

    const dadosParaDownload = [['EID', 'ICCID', 'Linha', 'Rede', 'Tipo de SIM'], ...linhas]

    exportarXlsx(dadosParaDownload, 'Linhas_invalidas.xlsx')
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens


  if (mostrarMensagemAtencao) {
    return (
      <MensagemAtencao
        handleMensagemAtencao={handleMensagemAtencao}
        mensagemTitulo="Não é possível realizar esta ação"
        mensagemParagrafo1="Esta ação não está disponível para dispositivos com eSIM."
        mensagemBotao="Fechar"
        semBotaoCancelar

      />
    )
  }

  return (
    <div>
      <Modal
        titulo={acaoTitle}
        width="880px"
        opened={opened}
        close={onClose}
        confirmLabel='Confirmar'
        onConfirm={onConfirm}
        positionTitle="left"
        showActionsModal
        hasReportDownload
        onReportDownload={handleMontarXlsLinhasNaoEncontradas}
      >
        <S.Container>
          <S.MensagemAlerta>
            Alguns itens selecionados <S.MensagemBold>não são elegíveis</S.MensagemBold> para esta ação e foram removidos da lista. Revise abaixo os itens  antes de prosseguir.
          </S.MensagemAlerta>
          <S.Card>
            <PaginationProvider pagination={Paginador(opcoesPaginacao)}>
              {({ paginationProps, paginationTableProps }) => (
                <>
                  <S.ContainerTable>
                    <BootstrapTable
                      classes="tabela"
                      condensed
                      keyField={TableprimaryKey}
                      data={linhasInvalidas}
                      columns={columns}
                      bootstrap4
                      bordered={false}
                      noDataIndication="Nenhuma linha selecionada"
                      {...paginationTableProps}
                    />
                  </S.ContainerTable>

                  <S.ContainerPagination>
                    <S.PaginationDescription className="pagination-description">
                      Mostrando
                      <span className="label-tabela-itens-exibidos">
                        {contador + 1}
                      </span>
                      -
                      <span className="label-tabela-itens-exibidos">
                        {getLimiteNaPagina()}
                      </span>
                      de
                      <span className="label-tabela-itens-exibidos">
                        {totalItens}
                      </span>
                    </S.PaginationDescription>

                    <div className="pagination-table">
                      <PaginacaoTabela
                        preview
                        setPaginaAtual={trocarPagina}
                        totalPaginas={totalPaginas}
                        totalItens={totalItens}
                        valorLimite={valorLimite}
                        paginaAtual={paginaAtual}
                        page={paginationProps.page}
                        onPageChange={paginationProps.onPageChange}
                      />
                    </div>
                  </S.ContainerPagination>
                </>
              )}
            </PaginationProvider>
          </S.Card>

          <Alert
            type="warning"
            title="Esta ação não está disponível para dispositivos com eSIM."
            message="Ao prosseguir, a ação continuará apenas com os itens elegíveis."
          />
        </S.Container>
      </Modal>
    </div>
  )
}
